import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";
import { RecentlyOpenedItemConfigurationProps, useResolveRecentlyOpenedItemForPersistence } from "./useResolveRecentlyOpenedItemForPersistence";
import { useRecentlyOpenedResults } from "client/Features/Search/RecentSearch/Persistence/useRecentlyOpenedResults";
import { useCallback } from "react";
import { navigateTo } from "client_legacy/ndaw/navigator";

export type EgnyteNavigationHandlerProps = {
	url: string;
}
	& RecentlyOpenedItemConfigurationProps;

export function useEgnyteNavigationHandler(props: EgnyteNavigationHandlerProps): (() => void) {
	const {
		url
	} = props;

	const { registerFromRecentlyOpened: registerRecentlyOpenedItem } = useRecentlyOpenedResults();

	const recentlyOpenedItem: GlobalSearchItemPersistedModel = useResolveRecentlyOpenedItemForPersistence(props);

	return useCallback(
		(): void => {
			registerRecentlyOpenedItem(recentlyOpenedItem);
			navigateTo(url, true);
		},
		[
			registerRecentlyOpenedItem,
			recentlyOpenedItem,
			url
		]
	);
}